<template lang="html">

<div :class="['seek',{'noBorder':noBorder}]">
    <div class="s-search">
         <div class="s-icon">
              <van-icon class="icon" class-prefix="iconfont" name="search" />
         </div>
         <div class="s-inpt">
              <input placeholder="搜索专辑、单曲" type="text" v-model="searchText">
         </div>
         <div class="s-text" @click="goSeek">
              <span>搜索</span>
         </div>
    </div>
</div>

</template>

<script>
import vEmits from "@/utils/vEmits";
export default {
     props:['intext','noBorder'],
     data(){
          return{
               searchText:''
          }
     },
     methods:{
          goSeek:function(){
               let vtext = this.searchText.replace(/\s+/g,"");
               let urlName = this.$route.name;
               if(urlName == 'seek'){
                   this.$emit('goSeek',this.searchText);
               }else if(vtext.length > 0){
                   this.push({
                        path:'seek',
                        query:{
                           stext:vtext
                        }
                   });
               }else{
                   vEmits.$emit('show','请输入检索关键字 !');
               }

          },
          urlSeek:function(){
              let urlName = this.$route.name;
              if(urlName != 'seek'){
                  this.push({
                       path:'seek'
                  });
              }
          }
     },
     created:function(){
          if(this.intext){
             this.searchText = this.intext
          }
     }
}
</script>

<style lang="css" scoped>

.seek{
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f1f1f1;
    background: white;
}

.seek.noBorder{
    border-bottom:1px solid white;
}

.s-search{
    height: 40px;
    margin: 0 auto;
    border-radius: 3px;
    border: 1px solid #cccccc;
    position: relative;
    display: flex;
    width: 90%;
    align-items: center;
}

.seek.noBorder .s-search{
    width: 100%;
}

.s-icon{
    width: 45px;
    text-align: center;
    flex-shrink: 0;
}

.s-icon .icon{
   font-size: 24px;
   color:rgba(0,0,0,0.3);
}

.s-inpt{
    flex-grow: 1;
    position: relative;
    margin-right: 10px;
}

.s-inpt input{
    border: none;
    width: 100%;
    height: 32px;
    font-size: 14px;
    background: transparent;
}

.s-text{
    width: 54px;
    flex-shrink: 0;
    text-align: center;
    border-left: 1px solid #999999;
}

.s-text span{
    font-size: 15px;
}

</style>
